import includes from 'lodash/includes';

export const delay = milliseconds => new Promise(_ => setTimeout(_, milliseconds));

export const isSupportedLanguage = language => includes(['es', 'en', 'pt'], language);
